import ReservationClockSvg from '@assets/images/svg/reservation-clock.svg';
import React from 'react';
import { View } from 'react-native';

export interface ReservationClockIconProps {
  size?: number;
  color?: string;
}

/** Figma reservation status — awaiting signature clock */
export function ReservationClockIcon({
  size = 22,
  color = '#E64A19',
}: Readonly<ReservationClockIconProps>) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <ReservationClockSvg width={size} height={size} color={color} />
    </View>
  );
}

export default ReservationClockIcon;
